import React, { useEffect, Fragment } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { BsChevronLeft } from "react-icons/bs";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights";
import JockeyDetail from "../Components/Modal/JockeyModal";

/**
 * JockeyDetailPage
 * ─────────────────────────────────────────────
 * A full standalone page for a single Jockey.
 * URL patterns supported:
 *   /jockey-detail?<id>          (query-string style)
 *   /jockey-detail/:id           (param style)
 *
 * The page renders:
 *  1. A common-page-banner with the jockey name + "Details" heading
 *  2. A white container with a dark top-header-bar (back-arrow + jockey name)
 *  3. The existing JockeyDetail modal component embedded directly
 */
const JockeyDetailPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { id: paramId } = useParams();
  const cookiedata = Cookies.get("i18next");
  const dispatch = useDispatch();

  // Accept both URL patterns: /jockey-detail?<id>  or  /jockey-detail/:id
  const id = paramId || location.search.slice(1) || location.state?.id;

  const { data: singlejockey, status } = useSelector(
    (state) => state.singlejockey
  );

  useEffect(() => {
    // Scroll to top on load
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);

  const jockeyName =
    singlejockey && status !== "loading"
      ? cookiedata === "en"
        ? singlejockey.NameEn || ""
        : singlejockey.NameAr || singlejockey.NameEn || ""
      : "";

  const bannerTitle = jockeyName 
    ? jockeyName 
    : t("Jockey");

  return (
    <Fragment>
      {/* ── Banner ── */}
      <div className="common-page-banner">
        <h1>{bannerTitle}</h1>
      </div>

      <div className="container-fluid new-main-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="new-race-detail-container col-sm-12"
                dir={cookiedata?.startsWith("ar") ? "rtl" : "ltr"}
                style={{ background: "rgb(255,255,255)", borderRadius: "10px" }}
              >
                {/* ── Dark top header bar ── */}
                <div
                  className="new-race-top-header-bar"
                  style={{ background: "rgb(10 31 67)" }}
                >
                  <div className="new-header-left-side">
                    <div
                      className="new-header-title-group"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <BsChevronLeft
                        className="new-back-arrow"
                        onClick={() => navigate(-1)}
                        style={{ cursor: "pointer" }}
                      />
                      <h2 className="new-header-track-name">{jockeyName || t("Loading...")}</h2>
                    </div>
                  </div>
                </div>

                {/* ── Main Jockey detail content ── */}
                {id ? (
                  <div style={{ padding: "10px 0" }}>
                    <JockeyDetail data={{ _id: id }} />
                  </div>
                ) : (
                  <div className="py-5 text-center">
                    <p style={{ color: "#888", fontSize: "18px" }}>
                      {t("No jockey selected.")}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <CoptRight />
    </Fragment>
  );
};

export default JockeyDetailPage;
